module.exports = __webpack_public_path__ + "img/download-on-the-app-store-es.ebdcadff.svg";